import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonetadm.widget.user.plus');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-portal-kreonetadm-widget-user-plus',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonetadm.widget.user.plus/view.scss */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 50%;
  margin-left: 380px;
  max-width: 1236px;
  min-width: 300px;
}

.btn-box {
  margin: auto;
  gap: 0.5rem;
  margin-top: 2rem;
}

.btn-remove {
  border: 1px solid #6D6D6D;
  width: 210px;
  height: 40px;
  border-radius: 8px;
  background-color: white;
  color: #5D5D5D;
}

.btn-blue {
  width: 210px;
  height: 40px;
  border: none;
  color: white;
  background: #5263FF 0% 0% no-repeat padding-box;
  border-radius: 8px;
}`],
})
export class PortalKreonetadmWidgetUserPlusComponent implements OnInit {
    @Input() title: any;
    @Input() isOpen = true;
    public user = {
        name: '',
        email: '',
        institute: '',
        ins_role: '',
        mobile: '',
        tel: '',
        department: '',
        title: '',

    }

    public async ngOnInit() {
    }

    public async plusUser() {
        const { code, data } = await wiz.call("plus_user", this.user)
        console.log(this.user)
    }


    public async closeModal() {
        this.isOpen = false;
    }

}

export default PortalKreonetadmWidgetUserPlusComponent;